// export const FETCH_COUNTRIES_START = "GET_COUNTRIES_START";
export const FETCH_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const FETCH_COUNTRIES_FAIL = "GET_COUNTRIES_FAIL";

export const FETCH_BANNERIMAGES_SUCCESS = "FETCH_BANNERIMAGES_SUCCESS";
export const FETCH_BANNERIMAGES_FAIL = "FETCH_BANNERIMAGES_FAIL";
